export const ANCHOR = 'how-to-cite';
